import {toRem} from './utils'

export const space = {
  xxs: toRem(6),
  xs: toRem(8),
  sm: toRem(10),
  md: toRem(12),
  lg: toRem(16),
  xl: toRem(24),
  xxl: toRem(32),
  xxxl: toRem(48),
  borderedBoxPaddingSm: toRem(20),
} as const

export const gaps = {
  sideNav: '30px',
}

export const borderWidths = {
  sm: '1px',
  md: '2px',
} as const

export const shadows = {
  sm: '1px 2px 4px 0 rgba(0,0,0,0.05)',
  v2: '0 0 .9375rem 0.3125rem rgba(0,0,0,.1)',
  bottom: '0 1.3px 2.5px rgba(0, 0, 0, 0.075), 0 10px 20px rgba(0, 0, 0, 0.15)',
} as const

export const transitions = {
  slow: '500ms cubic-bezier(0.41, 0.094, 0.54, 0.07)',
  medium: '300ms ease',
  fast: '100ms linear',
} as const

export const hovers = {
  raise: {
    transition: 'all 0.2s cubic-bezier(0, 0, 0.22, 1)',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: 'bottom',
      transform: 'translateY(-0.5rem)',
      zIndex: 5,
    },
  },
}

const siteContainer = '86rem'

// This is consumed by components/layout/Container/styles.tsx
export const containers = {
  default: {
    // This is the ACTUAL WIDTH of the content, since it applies to the
    // InnerContainer, and the padding below applies to the OuterContainer.
    maxWidths: {
      xs: siteContainer,
    },
    // Note that some other components refer to these theme values, especially
    // for full-bleed buttons that want to have the same padding on each side.
    paddings: {
      xs: '1rem',
      sm: '1.5rem',
      md: '2rem',
    },
  },
}

// This is consumed by components/layout/TextContainer/styles.tsx
//
// These maxWidths correspond to type sizes specified for various breakpoints in
// the TypographyTable below — ideally limiting line lengths to around 75 chars
// for optimal reading.
//
// If you adjust sizes for textMd, then you should update TextContainers
// maxWidths as well.
export const textContainers = {
  default: {
    maxWidths: {
      sm: '560px',
      xl: '600px',
      xxl: '720px',
    },
  },
  wider: {
    maxWidths: {
      // This used to be 75% but that doesn't work with flex-direction:
      // column, so use something that is approximately the same thing.
      md: `min(75vw, .75 * ${siteContainer})`,
    },
  },
  none: {
    maxWidths: {},
  },
}
